import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "main",
      component: () => import("./views/Main.vue"),
      children: [
        {
          path: "",
          name: 'home',
          component: () => import("./views/Home.vue")
        },
        {
          path: "/menu",
          name: "menu",
          component: () => import("./views/Menu.vue")
        },
        {
          path: "/addarticle",
          name: "addarticle",
          component: () => import("./views/AddArticle.vue")
        },
        {
          path: "/upload",
          name: "upload",
          component: () => import("./views/Upload.vue")
        },
        {
          path: "/upload2",
          name: "upload2",
          component: () => import("./views/Upload2.vue")
        },
        {
          path: "/role",
          name: "role",
          component: () => import("./views/sys/Role.vue")
        },
        {
          path: "/manager",
          name: "manager",
          component: () => import("./views/sys/Manager.vue")
        },
        {
          path: "/navigation",
          name: "navigation",
          component: () => import("./views/sys/Navigation.vue")
        },
        {
          path: "/common",
          name: "common",
          component: () => import("./views/stu/Common.vue")
        },
        {
          path: "/newstudent",
          name: "newstudent",
          component: () => import("./views/new/NewStudent.vue")
        },
        {
          path: "/studentlist",
          name: "studentlist",
          component: () => import("./views/new/StudentList.vue")
        },
        {
          path: "/mingye",
          name: "mingye",
          component: () => import("./views/new/Stu_Mingye.vue")
        },
        {
          path: "/mingyefollow",
          name: "mingyefollow",
          component: () => import("./views/stu/Follow.vue")
        },
        {
          path: "/mingyevip",
          name: "mingyevip",
          component: () => import("./views/new/Mingye_Vip.vue")
        },
        {
          path: "/mingyestage",
          name: "mingyestage",
          component: () => import("./views/new/Mingye_Stage.vue")
        },
        {
          path: "/mingyerefund",
          name: "mingyerefund",
          component: () => import("./views/new/Mingye_Refund.vue")
        },
        {
          path: "/vipstu",
          name: "vipstu",
          component: () => import("./views/stu/Vipstu.vue")
        },
        {
          path: "/follow",
          name: "follow",
          component: () => import("./views/stu/Follow.vue")
        },
        {
          path: "/assess",
          name: "assess",
          component: () => import("./views/stu/Assess.vue")
        },
        {
          path: "/pay",
          name: "pay",
          component: () => import("./views/stu/Pay.vue")
        },
        {
          path: "/visit",
          name: "visit",
          component: () => import("./views/stu/Visit.vue")
        },
        {
          path: "/signout",
          name: "signout",
          component: () => import("./views/stu/Signout.vue")
        },
        {
          path: "/msg_follow",
          name: "msg_follow",
          component: () => import("./views/msg/Follow.vue")
        },
        {
          path: "/msg_visit",
          name: "msg_visit",
          component: () => import("./views/msg/Visit.vue")
        },
        {
          path: "/collect_area",
          name: "collect_area",
          component: () => import("./views/collect/Area.vue")
        },
        {
          path: "/collect_school",
          name: "collect_school",
          component: () => import("./views/collect/School.vue")
        },
        {
          path: "/collect_preview",
          name: "collect_preview",
          component: () => import("./views/collect/Preview.vue")
        },
        {
          path: "/original",
          name: "original",
          component: () => import("./views/collect/Original.vue")
        },
        {
          path: "/collect_pay",
          name: "collect_pay",
          component: () => import("./views/collect/Pay.vue")
        },
        {
          path: "/collect_doc",
          name: "collect_doc",
          component: () => import("./views/collect/Doc.vue")
        },
        {
          path: "/collect_edu",
          name: "collect_edu",
          component: () => import("./views/collect/EduBack.vue")
        },
        {
          path: "/collect_year",
          name: "collect_year",
          component: () => import("./views/collect/AbroadYear.vue")
        },
        {
          path: "/paytime",
          name: "paytime",
          component: () => import("./views/collect/PayTime.vue")
        },
        {
          path: "/collect_market",
          name: "collect_market",
          component: () => import("./views/collect/Market.vue")
        },
        {
          path: "/japcommon",
          name: "japcommon",
          component: () => import("./views/jap/Common.vue")
        },
        {
          path: "/japfollow",
          name: "japfollow",
          component: () => import("./views/jap/Follow.vue")
        },
        {
          path: "/japcol_eduback",
          name: "japcol_eduback",
          component: () => import("./views/japcol/EduBack.vue")
        },
        {
          path: "/japcol_origin",
          name: "japcol_origin",
          component: () => import("./views/japcol/Origin.vue")
        },
        {
          path: "/japcol_area",
          name: "japcol_area",
          component: () => import("./views/japcol/Area.vue")
        },
        {
          path: "/japcol_payamount",
          name: "japcol_payamount",
          component: () => import("./views/japcol/PayAmount.vue")
        },
        {
          path: "/japcol_course",
          name: "japcol_course",
          component: () => import("./views/japcol/Course.vue")
        },
        {
          path: "/msg_japfollow",
          name: "msg_japfollow",
          component: () => import("./views/msg/JapFollow.vue")
        },
        {
          path: "/japsignout",
          name: "japsignout",
          component: () => import("./views/jap/Signout.vue")
        },
        {
          path: "/japvip",
          name: "japvip",
          component: () => import("./views/jap/Vip.vue")
        },
        {
          path: "/japcourse",
          name: "japcourse",
          component: () => import("./views/jap/Course.vue")
        },
        {
          path: "/mingyecourse",
          name: "mingyecourse",
          component: () => import("./views/new/MingyeCourse.vue")
        },
        {
          path: "/sch_school",
          name: "sch_school",
          component: () => import("./views/sch/School.vue")
        },
        {
          path: "/monthpercentage",
          name: "monthpercentage",
          component: () => import("./views/collect/MonthPercentage.vue")
        },
        {
          path: "/sel_visit",
          name: "sel_visit",
          component: () => import("./views/sel/Visit.vue")
        },
        {
          path: "/sel_convertjap",
          name: "sel_convertjap",
          component: () => import("./views/sel/ConvertJap.vue")
        },
        {
          path: "/sel_convertstu",
          name: "sel_convertstu",
          component: () => import("./views/sel/ConvertStu.vue")
        },
        {
          path: "/graduate",
          name: "graduate",
          component: () => import("./views/stu/Graduate.vue")
        },
        {
          path: "/partner",
          name: "partner",
          component: () => import("./views/stu/Partner.vue")
        },
        {
          path: "/student_Exprience",
          name: "student_Exprience",
          component: () => import("./views/this/Student_Exprience.vue")
        },
        {
          path: "/siteconfig",
          name: "siteconfig",
          component: () => import("./views/sys/SiteConfig.vue")
        },
        {
          path: "/ereason",
          name: "ereason",
          component: () => import("./views/stu/EReason.vue")
        },
        {
          path: "/progressTemplate",
          name: "progressTemplate",
          component: () => import("./views/mini/ProgressTemplate.vue")
        },
        {
          path: "/studentProgress",
          name: "studentProgress",
          component: () => import("./views/mini/StudentProgress.vue")
        },
        {
          path: "/stucollect",
          name: "stucollect",
          component: () => import("./views/new/Stu_Collect.vue")
        },
        {
          path: "/stujapcollect",
          name: "stujapcollect",
          component: () => import("./views/new/StuJap_Collect.vue")
        },
      ]
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/Login.vue")
    },
  ]
});
